import Luiv3Constants, {LuiV3ColorKey} from '@app/lui3/constants';
import styled from 'styled-components';

import AbsLayer from './AbsLayer';

interface Props {
  outlineColor: LuiV3ColorKey;
}

const OutlineDisabledBaseLayer = styled(AbsLayer)<Props>`
  border: solid var(--theme-border-thickness)
    ${({outlineColor}) => Luiv3Constants.baseColor[outlineColor]};
  opacity: 0.38;
`;

export default OutlineDisabledBaseLayer;
